import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { CorrespondenceAddress } from "../../../../../../../Wrap/Models/Models/Instructions/CorrespondenceAddress";
import { CorrespondenceAddressOwner } from "./CorrespondenceAddressOwner";
import { FirmAddress } from "./FirmAddress";
import { ContactOwnerType } from "../../../../../../../Wrap/Models/Models/Instructions/ContactOwnerType";

interface IFirmCorrerspondenceAddressProps extends React.Props<FirmCorrespondenceAddress> {
    isReview: boolean;
    instructionId: number;
    correspondenceAddress: CorrespondenceAddress;
    onChange: (v: CorrespondenceAddress) => void;
    onRef: (ref) => void;
}

interface IFirmCorrespondenceAddress {}
export class FirmCorrespondenceAddress extends FormComponent<
    IFirmCorrerspondenceAddressProps,
    IFirmCorrespondenceAddress
> {
    constructor(props: any) {
        super(props);
    }
    componentDidMount() {
        this.props.onRef(this);
    }

    child: Array<any> = [];
    public render(): JSX.Element {
        return (
            <>
                <CorrespondenceAddressOwner
                    disabled={this.props.isReview}
                    name={this.props.correspondenceAddress?.Name}
                    onChange={(v) => this.onOwnerChange(v)}
                    onRef={(ref) => this.child.push(ref)}
                />

                <FirmAddress
                    OwnerType={ContactOwnerType.Company}
                    notRequired={true}
                    isReview={this.props.isReview}
                    instructionId={this.props.instructionId}
                    onRef={(ref) => this.child.push(ref)}
                    data={this.props.correspondenceAddress?.Address}
                    onChange={(v) => this.onAddressChange(v)}
                />
            </>
        );
    }

    private onOwnerChange(owner) {
        let { correspondenceAddress } = this.props;
        if (!correspondenceAddress) {
            correspondenceAddress = this.emptyCorrespondenceAddress();
        }
        correspondenceAddress.Name = owner;
        this.props.onChange(JSON.parse(JSON.stringify(correspondenceAddress)));
    }

    private onAddressChange(changes) {
        let { correspondenceAddress } = this.props;
        if (!correspondenceAddress) {
            correspondenceAddress = this.emptyCorrespondenceAddress();
        }
        correspondenceAddress.Address = changes;
        this.props.onChange(JSON.parse(JSON.stringify(correspondenceAddress)));
    }

    private emptyCorrespondenceAddress(): CorrespondenceAddress {
        return {
            Address: null,
            Name: null,
        };
    }
}
